// Libs
import { View } from '@react-pdf/renderer';
// Components, Layouts, Pages
// Others
import { DEFAULT_NUMBER_ZERO } from '~/utils/constants/common';
// Styles, images, icons

type Props = {
  width?: number;
  height?: number;
};

const Space = (props: Props) => {
  //#region Destructuring Props
  const { height = DEFAULT_NUMBER_ZERO, width = DEFAULT_NUMBER_ZERO } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return <View style={{ width, height }} />;
};

export default Space;
